// @ts-nocheck

import palette from '../palette';

export const DesktopNavigationBar = {
  backgroundColor: palette.black,
  color: palette.white,
};

export const DesktopNavigationBarTitle = {
  color: palette.neutralgrey350,
};

export const DesktopNavigationBarItem = {
  active: {
    color: palette.white,
    backgroundColor: palette.black,
    afterBackgroundColor: palette.red200,
  },
  passive: {
    color: palette.neutralgrey550,
    backgroundColor: palette.black,
    afterBackgroundColor: palette.transparent,
  },
};
